import { ListCustomerNotesResponseSchema } from '@vy/api-definition';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../../../../../services/api';
import { queryKeys } from '../../../../../../services/query-key/query-keys';

export const useCustomerNotes = (customerId: string) => {
  return useQuery({
    queryKey: queryKeys.customerNotes(customerId),
    queryFn: async () => {
      const api = getPrivateApi();

      const customerNotesResponse = await api.listCustomerNotes({ customerId });

      return ListCustomerNotesResponseSchema.parse(customerNotesResponse);
    },
  });
};
